import { useEffect, useMemo, useState } from "react";
import { CountingFrom, Value } from "../http/onlyclicksApi";
import BottomSheet from "./BottomSheet";
import Button from "./Button";
import styles from "./SettingsEditorBottomSheet.module.css";
import Stepper from "./Stepper";

interface Props {
  label: string;
  value?: Value<number>;
  unit: string;
  step?: number;
  minValue?: number;
  maxValue?: number;
  isOpen: boolean;
  countingFrom: CountingFrom;
  onClose: () => void;
  onChange: (number?: number) => void;
}

const SettingsEditorBottomSheet = ({
  label,
  value,
  unit,
  step,
  minValue,
  maxValue,
  isOpen,
  countingFrom,
  onClose,
  onChange,
}: Props) => {
  const isModified = value?.curr !== value?.prev;
  const [newValue, setNewValue] = useState(value?.curr);
  useEffect(() => {
    setNewValue(value?.curr);
  }, [value]);

  const isValid = useMemo(() => {
    return (
      newValue != null &&
      (minValue == null || newValue >= minValue) &&
      (maxValue == null || newValue <= maxValue)
    );
  }, [newValue, minValue, maxValue]);

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose}>
      <h3>{label}</h3>
      {isModified && (
        <p className={styles.caption}>
          Original value:{" "}
          <span className={styles.originalValue}>{value?.prev ?? "N/A"}</span>
        </p>
      )}
      <Stepper
        unit={unit}
        size="large"
        value={newValue}
        step={step}
        minValue={minValue}
        maxValue={maxValue}
        autoFocus={true}
        onChange={(e) => setNewValue(e)}
        className={styles.stepper}
        countingFrom={countingFrom}
      />
      {!isValid && (
        <span className={styles.error}>
          value must be between {minValue} and {maxValue}
        </span>
      )}
      <Button
        fullWidth={true}
        buttonProps={{
          type: "button",
          className: styles.button,
          onClick: () => {
            if (isValid) {
              onChange(newValue);
              onClose();
            }
          },
        }}
      >
        Done
      </Button>
    </BottomSheet>
  );
};

export default SettingsEditorBottomSheet;
